<template>
  <div>
    <el-button
      type="primary"
      class="addBtn"
      @click="addAdminClick"
      v-if="operations.includes('新增管理员')"
    >添加管理员</el-button>
    <el-input
      placeholder="请输入管理员姓名"
      v-model="keyword_search"
      clearable
      class="input"
    >
    </el-input>
    <el-button
      type="primary"
      class="searchBtn"
      @click="getAdminList"
    >筛选</el-button>
    <div class="table-wrap">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="ID"
          width="60"
          align="center"
          :index="handlerSerial"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="管理员姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="account"
          label="账号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="group.title"
          label="管理员身份"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="160"
        >
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span
                class="operation-item"
                @click="editAdminClick(scope.row)"
                v-if="operations.includes('编辑管理员')"
              >编辑</span>
              <span
                class="danger operation-item"
                @click="deleteAdminClick(scope.row)"
                v-if="operations.includes('删除管理员')"
              >删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <common-pagination
        :total="total"
        :page_size="page_size"
        @size-change="handelPagesizeChange"
        @page-change="handlePageChange"
      ></common-pagination>
    </div>
    <common-dialog
      :title="dialogTitle"
      :dialogVisible="dialogVisible"
      @cancel="dialogCancelClick"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div class="dialog-body-wrap">
        <!-- <div v-if="dialogType === 'add' || dialogType === 'edit' ">
      		
      	</div> -->
        <div v-if="dialogType ==='delete'">
          是否删除管理员？
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import CommonPagination from "@/components/CommonPagination";
import CommonDialog from "@/components/CommonDialog";
import {
  getAuthList,
  identityOf,
  addAdminUser,
  editAuthUser,
  delAuthUser
} from "@/api/auth";
import { mapState } from "vuex";
import operations from "@/mixins/operations";

export default {
  mixins: [operations],
  data() {
    return {
      tableData: [],
      page_index: "1", //第几页
      page_size: "10",
      total: 0, //总条数
      dialogVisible: false,
      dialogTitle: "",
      dialogType: "",
      handle_row: {},
      three_rules: [],
      keyword_search: ""
    };
  },
  components: {
    CommonPagination,
    CommonDialog
  },
  computed: {
    ...mapState(["operationList"])
  },
  mounted() {
    this.getAdminList();
  },
  methods: {
    async getAdminList() {
      let postData = {
        page_size: this.page_size,
        page_index: this.page_index,
        keyword_search: this.keyword_search
      };
      const {
        status,
        data: { result: resData }
      } = await getAuthList(postData);
      if (status !== 200) return;
      if (resData.data.length) {
        //后端返回手机号字段和提交时字段不一致
        resData.data.forEach(item => {
          item.user_mobile = item.mobile;
        });
      }
      this.tableData = resData.data;
      this.total = resData.total;
      console.log(resData, "admin list");
    },
    addAdminClick() {
      this.$router.push("/add-admin");
    },
    editAdminClick(row) {
      this.$router.push({
        path: "/edit-admin",
        query: {
          uuid: row.uuid
        }
      });
    },
    deleteAdminClick(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.dialogType = "delete";
      this.dialogTitle = "删除管理员";
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this.getAdminList();
    },
    handlePageChange(page) {
      this.page_index = page;
      this.getAdminList();
    },
    handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    async dialogConfirmClick() {
      if (this.dialogType === "add" || this.dialogType === "edit") {
        const { name, user_mobile, account, password, group_id } = this.form;
        if (!name) {
          this.$message("管理员姓名不能为空");
          return;
        }
        if (!user_mobile) {
          this.$message("手机号不能为空");
          return;
        }
        if (!/^1[34578]\d{9}$/.test(user_mobile)) {
          this.$message("手机号格式错误");
          return;
        }
        if (!account) {
          this.$message("管理员账号不能为空");
          return;
        }
        if (!password && this.dialogType === "add") {
          this.$message("管理员密码不能为空");
          return;
        }
        if (!group_id) {
          this.$message("请选择管理员身份");
          return;
        }
        this.form.is_order_notice = this.checked ? "1" : "2";
      }
      if (this.dialogType === "add") {
        const { status } = await addAdminUser(this.form);
        if (status === 200) {
          this.dialogVisible = false;
          return;
        }
      }
      if (this.dialogType === "edit") {
        const { status } = await editAuthUser(this.form);
        if (status === 200) {
          this.dialogVisible = false;
          return;
        }
      }
      if (this.dialogType === "delete") {
        const { status } = await delAuthUser(this.form.uuid);
        if (status === 200) {
          this.dialogVisible = false;
          return;
        }
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.checked = false;
      this.form = {};
      this.getAdminList();
    },
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations;
        }
      });
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf("添加") !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf("删除") !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf("编辑") !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      });
      console.log(this.three_rules, "three rules auth");
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
  .addBtn();
}
.input {
  width: 300px;
  margin-right: 30px;
}
.table-wrap {
  .table-wrap();
}
</style>
